import { render, staticRenderFns } from "./SignupModal.vue?vue&type=template&id=01f7b86a&scoped=true"
import script from "./SignupModal.vue?vue&type=script&lang=js"
export * from "./SignupModal.vue?vue&type=script&lang=js"
import style0 from "./SignupModal.vue?vue&type=style&index=0&id=01f7b86a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f7b86a",
  null
  
)

export default component.exports